import { actionCreators } from "../reducers";

export const identify = actionCreators.identify;
